import Form from './core/Form';
import Premise from "./core/Premise";
import Ckeditor from '../vendor/ckeditor/components/Ckeditor.vue';
import MyWarehouse from './components/profile/MyWarehouse.vue';
import ShowMap from './components/ShowMap';
import MapLocation from './components/MapLocation';
import ShowMapAll from "./components/ShowMapAll";


performance.mark('start_load_main');

window.Ckeditor = Ckeditor;

import CreateOrEditPremisesByUser
    from './components/premise/CreateOrEditPremisesByUser';


// element-ui
import {
    Cascader,
    DatePicker,
    Select,
    Option,
    Switch,
    Checkbox,
    Dialog,
    Rate,
} from 'element-ui';

import * as helpers from './core/Functions';
window.swal = require('sweetalert2');
require('es6-promise').polyfill();
require('../vendor/FileUpload/js/FileUpload');

Lang.setLocale(siteLang);

// https://github.com/davidchambers/string-format
let format = require('string-format');
format.extend(String.prototype, {});

window.helpers = helpers;
window.Form = Form;
window.premise = Premise;


// element-ui
Vue.component(Cascader.name, Cascader);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Switch.name, Switch);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Dialog.name, Dialog);
Vue.component(Rate.name, Rate);

// глобальный объект для модалок
window.modal = {
    type: '',
};

require('./snippets/slider');
require('./snippets/common');
require('./snippets/mobile-menu');
require('./snippets/premise');
require('./snippets/catalog');
require('./snippets/callback');
require('./snippets/auth');
require('./snippets/share_buttons');
require('./connect-comment');
require('./snippets/profile');
//lazy image load
import Blazy from 'blazy';

window.Blazy = Blazy;

setTimeout(function () {
    new Blazy({
        breakpoints: [{
            width: 420,
            src: 'data-src-small'
        }]
    });
}, 500);

performance.mark('main_loaded');
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBx_V4SAyZU-DxIBuE8j34qAFX19PMyZT0',
        libraries: 'places',
    },
    installComponents: true
});
console.log('g-map VueGoogleMaps');
if (document.getElementById('create-or-edit-premises-by-user')) {
    new Vue({
        el: '#create-or-edit-premises-by-user',
        components: {
            CreateOrEditPremisesByUser
        },
    });
}
if (document.getElementById('show-map')) {
    new Vue({
        el: '#show-map',
        components: {
            ShowMap,
        },
    });
}
if (document.getElementById('map-location')) {
    new Vue({
        el: '#map-location',
        components: {
            MapLocation,
        },
    });
}
if (document.getElementById('my-warehouse')) {
    new Vue({
        el: '#my-warehouse',
        components: {
            MyWarehouse
        },
    });
}

if (document.getElementById('show-map-all')) {
    new Vue({
        el: '#show-map-all',
        components: {
            ShowMapAll,
        },
    });
}



// WEBPACK FOOTER //
// ./resources/js/main.js